import React from 'react';

/**
 * Unified ProgressBar component for both Focus Mode and non-Focus views
 * 
 * @param {number} totalMs - Total duration in milliseconds
 * @param {number} elapsedMs - Elapsed time in milliseconds  
 * @param {boolean} isPaused - Whether the timer is currently paused
 * @param {string} className - Additional CSS classes for container
 */
const ProgressBar = ({ totalMs, elapsedMs, isPaused, className = "" }) => {
  // Compute progress from elapsed time (never use remaining)
  // Clamp to ensure 0 <= progress <= 1
  const progress = totalMs > 0 ? Math.max(0, Math.min(1, elapsedMs / totalMs)) : 0;
  
  // Convert to percentage for CSS
  const progressPercent = progress * 100;

  return (
    <div className={`relative bg-slate-700 rounded-full overflow-hidden h-2 ${className}`}>
      <div
        className="absolute inset-y-0 left-0 bg-white rounded-full transition-all duration-150 ease-out"
        style={{ 
          width: `${progressPercent}%`,
          transformOrigin: 'left'
        }}
      />
    </div>
  );
};

export default ProgressBar;